import { Text, TextProps } from '@chakra-ui/react';
import * as React from 'react';

import { Semibold } from '@/imports/ui/chakra/components/Semibold';

import { IQuestionAnswerData } from '../../types';
import { getTextContentForPost } from '../../utils';

type IQuestionAnswerTextContentProps = {
  data: IQuestionAnswerData;
} & TextProps;

export const QuestionAnswerTextContent: React.FC<
  IQuestionAnswerTextContentProps
> = (props) => {
  const { data, ...rest } = props;
  const content = getTextContentForPost(data.post);

  return (
    <Text {...rest}>
      <Semibold>{data.firstActor.displayName}</Semibold>{' '}
      {data.numUniqueActors > 1
        ? `and ${data.numUniqueActors - 1} other${
            data.numUniqueActors > 2 ? 's' : ''
          } `
        : ''}
      answered your question
      <Semibold>{`${content ? `: ${content}` : ''}`}</Semibold>
    </Text>
  );
};
